import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { CLICKABLE_COLOR } from '@CSSVars/colors'

export const _ShowMore = styled.div`
  display: ${({ hide }) => (hide ? 'none' : 'inline-block')};
  width: 100%;
  color: ${CLICKABLE_COLOR};
  margin-top: 15px;
  padding-left: 10px;


  &:hover {
   cursor: pointer;
  }

`
